<template>
    <Modal size="lg"
           height="full-height"
           :cancel="cancel"
           :ok="ok"
           icon="fa-sticky-note"
           :shaded-body="true"
           title="ORDER_NOTES.MODAL_TITLE">
        <form class="form-v"
              @submit.prevent="ok">
            <div class="form-group">
                <textarea ref="notes"
                          v-model="notes"
                          :placeholder="notesPlaceholder"
                          class="form-control input-lg"></textarea>
            </div>
        </form>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: { Modal },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        orderNotes: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            notes: this.orderNotes,
        };
    },

    computed: {
        notesPlaceholder() {
            return container.langService.getText('ORDER_NOTES.ADD_NOTES');
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.notes.focus();
        });
    },

    methods: {
        ok() {
            return this.resolve(this.notes);
        },
    },
};
</script>

<style lang="less" scoped>
.form-v,
.form-group,
.input-lg {
    height: 100%;
    resize: none;
}
</style>
